import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {fetchHistoryById} from "../API/api";
import {putQuote} from "./ProjectsSlice";

export const getHistoriesById = createAsyncThunk(
    'history',
    async (queryParams, {rejectWithValue}) => {
        try {
            const response = await fetchHistoryById(queryParams.id, queryParams.entityType);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

const historiesSlice = createSlice({
    name: "histories",
    initialState: {
        byId: {},
        status: 'idle',
        error: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(getHistoriesById.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getHistoriesById.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.byId[action.payload.id] = action.payload;
            })
            .addCase(getHistoriesById.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
            .addCase(putQuote.fulfilled, (state, action) => {
                // Doing this to force the quote details page to fetch history again,
                // without requiring a user to refresh the page to see the updates
                state.byId[action.meta.arg.id] = undefined;
            });
    }
})

export const selectHistoriesById = (state) => state.histories.byId;
export default historiesSlice.reducer;